import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { Price } from "../common/Price";

const OrderDetailTotal = ({
  customer,
  totalQuantity,
  totalPrice,
  displayableQuantityD = null,
  sx,
}) => {
  return (
    <Flex
      w={1}
      bg="#f7f7f7"
      sx={{
        color: "black",
        borderTop: "1px solid #C2C2C2",
        borderBottom: "1px solid #C2C2C2",
        justifyContent: "space-between",
        padding: "8px",
        ...sx,
      }}
    >
      <Flex w={1} flex={1}>
        {displayableQuantityD?.map?.((e, i) => {
          return (
            <Flex key={i}>
              <Flex
                flexDirection={"column"}
                style={{
                  alignItems: "center",
                  justifyContent: "left",
                  paddingLeft: "16px",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.5em",
                    paddingRight: "5px",
                  }}
                >
                  DOOR
                </Box>
                <Box
                  style={{
                    width: "100%",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid black",
                    paddingRight: "4px",
                  }}
                >
                  {customer &&
                    customer.doors &&
                    customer.doors.length > 0 &&
                    customer.doors.find((door) => door.id == e[0])?.code}
                </Box>
              </Flex>
              <Flex
                flexDirection={"column"}
                sx={{
                  alignItems: "center",
                  justifyContent: "left",
                  paddingRight: "16px",
                  paddingLeft: "4px",
                  ...(i + 1 !== displayableQuantityD?.length && {
                    borderRight: "1px solid black",
                  }),
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "right",
                    fontSize: "0.5em",
                  }}
                >
                  {getLocalizedString("QTA")}
                </Box>
                <Box
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "right",
                  }}
                >
                  {e[1]}
                </Box>
              </Flex>
            </Flex>
          );
        })}
      </Flex>
      <Flex sx={{ height: "100%" }}>
        <Box
          style={{
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "right",
            paddingRight: "10px",
          }}
        >
          {getLocalizedString("TOTALE")}
        </Box>
        <Box
          sx={{
            minWidth: "50px",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {totalQuantity || 0}
        </Box>
        <Box
          sx={{
            minWidth: "100px",
            borderLeft: "1px solid #C2C2C2",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Price price={totalPrice}></Price>
        </Box>
      </Flex>
    </Flex>
  );
};

export default OrderDetailTotal;
